export default "__VITE_ASSET__CgEUWixW__"